import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import ReactDOM from 'react-dom/client'
import App from '../components/App';

const spaRoot = document.getElementById('react-spa-root');
if (spaRoot) {
  const root = ReactDOM.createRoot(spaRoot);
  root.render(
    <Router basename="/a">
      <App />
    </Router>
  );
}
